import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { forkJoin, Subject, takeUntil } from 'rxjs';
import { CustomizerSettingsService } from 'src/app/components/customizer-settings/customizer-settings.service';
import { uploadModule } from 'src/app/core/constants/permission';
import { fileSizeAndExtension, fileType, validateUploadDoc, viewDocument } from 'src/app/core/helpers/helperfunc';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { MyDriveService } from 'src/app/core/services/myDrive/my-drive.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';

@Component({
  selector: 'app-create-file-dialog',
  templateUrl: './create-file-dialog.component.html',
  styleUrls: ['./create-file-dialog.component.scss']
})
export class CreateFileDialogComponent implements OnInit, OnDestroy {
  viewDocument = viewDocument;
  upload_const = uploadModule;
  validate_upload_doc = validateUploadDoc;
  files: File[] = [];
  file_type = fileType;
  private _unsubscribeAll: Subject<any> = new Subject();

  constructor(
    public dialogRef: MatDialogRef<CreateFileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _driveService: MyDriveService,
    private _loaderService: LoaderService,
    private _toasterService: ToasterService
  ) { }

  ngOnInit(): void {
  }

  close(val?: boolean) {
    this.dialogRef.close(val);
  }

  onSelectFile(event: any) {
    if (event.addedFiles?.length) {
      event.addedFiles.forEach(element => {
        this.files.push(element);
      })
      this.upload();
    }
  }

  onRemove(event: any) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  public upload(): void {
    if (!this.files.length) {
      this._toasterService.showError('ERROR', 'Please select file to upload');
      return;
    }
    const requestsList = this.constructFileUploadPayload();
    this.uploadFile(requestsList);
  }

  constructFileUploadPayload() {
    return this.files.map((item, index) => {
      let formData = new FormData();
      formData.append('files', item);
      formData.append('filePath', this.data?.filePath ?? '/');

      return this._driveService.uploadFile(formData);
    })
  }
  
  uploadFile(requestsChain) {
    this._loaderService.showLoader();
    forkJoin(requestsChain)
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe({
      next: (event: any) => {
        this._loaderService.hideLoader();
        this._toasterService.showSuccess('SUCCESS', 'File uploaded successfully');
        this.close(true);
      },
      error: (err: any) => {
        this._toasterService.showError('ERROR', err?.error?.data);
        this._loaderService.hideLoader();
      }
    })
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
